import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const infoThemeNhs = createTheme(
  `InfoNhs`,
  defaultTheme.api,
  {
    colors: {
      primaryBackground: `bluePale`,
      primaryBackgroundStart: `bluePale`,
      primaryBackgroundEnd: `bluePale`,
      primaryIcon: `blueDark`,
    },
  },
  defaultTheme
)

export default infoThemeNhs
